import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { withI18next } from 'lib/i18n/withI18next'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import Typo from 'constants/typography'
import Accordion from 'components/common/accordion'
import Badge from 'components/common/badge'
import { BADGE_COLOR } from 'components/common/badge/const'
import FindThisItemAccordionDetails from './accordion-details'
import styles from './styles.scss'
import {
  getStockBadge,
  shouldDisplayDotValue,
  trackStoreAccordionOpen,
} from '../utils'

const FindThisItemAccordion = ({ productID, stockInfo, t }) => (
  <div>
    <style jsx>{styles}</style>
    {stockInfo?.map((store, idx) => (
      <div key={store.name} className="store-details">
        <Accordion
          title={
            <div className="detail">
              <div className={clsx(Typo.subtitle2, 'detail__title')}>
                <span className="number">{idx + 1}</span>
                <span className={Typo.subtitle1}>{store.name}</span>
                {getStockBadge(store.available_stock, t) && (
                  <Badge
                    color={BADGE_COLOR.secondary}
                    content={getStockBadge(store.available_stock, t)}
                    contentClassName={Typo.overline}
                  />
                )}
              </div>
              <div className="detail__sub-detail">
                {store.floor_level && (
                  <span className={Typo.body2}>
                    {`${store.floor_level} Floor`}
                  </span>
                )}
                {shouldDisplayDotValue(store) && <div>•</div>}
                {store.nearest_station && (
                  <React.Fragment>
                    <Icon
                      alt="train-icon"
                      src={ICONS.trainStation}
                      size={ICON_SIZE.default}
                    />
                    <span className={Typo.body2}>{store.nearest_station}</span>
                  </React.Fragment>
                )}
              </div>
            </div>
          }
          onChange={(isAccordionOpen) =>
            trackStoreAccordionOpen({ isAccordionOpen, store, productID })
          }
          withArrow
        >
          <FindThisItemAccordionDetails store={store} />
        </Accordion>
      </div>
    ))}
  </div>
)

FindThisItemAccordion.propTypes = {
  productID: PropTypes.number.isRequired,
  stockInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(FindThisItemAccordion)
